import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {AccessRoleSearchModel} from "../access-role-search.model";
import {AccessRoleSearchPageComponent} from "../access-role-search-page/access-role-search-page.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-access-role-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(AccessRoleSearchModel),
        registerSearchControl(AccessRoleMultiSelectSearchControlComponent)
    ]
})
export class AccessRoleMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<AccessRoleSearchModel> {
    constructor(model: AccessRoleSearchModel, injector: Injector) {
        super(model, injector, "accessRoleId", "name");

        this.extendedSearchComponent = AccessRoleSearchPageComponent;
    }
}
